import * as React from 'react';
import { DetailsList,  DetailsListLayoutMode,  SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Label } from 'office-ui-fabric-react/lib/Label';

import './css/Site.css';
import './css/Fatture.css';

import { Config } from './Config.js';
import { Azioni } from './classi/Azioni.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';


const sessione = new Session();
const config = new Config();
const azioni = new Azioni();
const utils = new Utils();

let _items: IDocument[] = [];

export class ElencoUtenti extends React.Component {

    constructor(){
        super();
        this.state = {
            utenti:[],
            utenzaGruppo : {
                RAGIONE_SOCIALE:'',
                INDIRIZZO:'',
                CAP:'',
                COMUNE:'',
                EMAIL:''
            },
            errorMessage: '',
            id_cliente: false,
            
            visualizza:'',
            visualizzaWarning:'nascosto',
            
            titoloPagina:''
        };
        
        this._popolaUtenti = this._popolaUtenti.bind(this);
        this._onChangeFiltraUtenti = this._onChangeFiltraUtenti.bind(this);
    }
                    
    componentDidMount() {
        this._popolaUtenti();
        
        let ID_AMMINISTRATORE = sessione.get('id_amministratore');
        let UG = sessione.get('utenzaGruppo');
        if(ID_AMMINISTRATORE>0){this.setState({titoloPagina: 'Lista Condomini' });}
        else{this.setState({titoloPagina: 'Lista Utenti' });}
        
        if( UG !== false && UG !== null ){
            this.setState({utenzaGruppo : UG });
        }
        
        utils.setBoxInfoCliente();
    }
    
    _popolaUtenti() {
        
        let ELENCO = sessione.get('elencoutenti');
        
        if( ELENCO !== null )
        {
            _items = ELENCO;
            this.setState({utenti: _items, visualizza:'', visualizzaWarning:'nascosto' });
        }
        else
        {    
            sessione.set('elencoutenti' , null );
            sessione.set('utenzaGruppo' , null );
            
            let request = new Request( config.get("anagrafica_elencoutenti"),{
                method: 'POST', mode: 'cors', credentials: "include", 
                body: JSON.stringify({ id_aggregato: sessione.get('id_aggregato') , id_amministratore: sessione.get('id_amministratore')  , id_cliente: sessione.get('id_cliente')  })
            });

            fetch(request)
            .then(function(response){
                return response.json();
            }).then(function(result){

                utils.gestisciMessaggio( result );

                if (result.success) {

                    _items = [];
                    let visualizza= 'nascosto';
                    let visualizzaWarning = 'warning centrato margin10';

                    if( 'utenti' in result.data && result.data.utenti !== null && result.data.utenti !== 'Non ci sono utenti da visualizzare.' )
                    {
                        // Elenco delle richieste
                        if ( result.data.utenti.length > 0) {

                            visualizza= '';
                            visualizzaWarning = 'nascosto';

                            for (let i = 0; i < result.data.utenti.length; i++) {
                              _items.push(result.data.utenti[i]);
                            }
                        }
                    }                    

                    sessione.set('elencoutenti' , _items );
                    sessione.set('utenzaGruppo' , result.data.datiutenza );

                    this.setState({utenti: _items, visualizza:visualizza, visualizzaWarning:visualizzaWarning , utenzaGruppo: result.data.datiutenza });

                } else {
                    this.setState({errorMessage: result.message, visualizza:'nascosto', visualizzaWarning:'warning centrato margin10'});
                }
            }.bind(this) );
        }
    }
    
    _onChangeFiltraUtenti(event) {
        this.setState({ utenti: event.target.value ? 
            _items.filter(i =>  ( i.COD_CLIENTE.toLowerCase().indexOf(event.target.value.toLowerCase() )>-1) || 
                                ( i.RAGIONE_SOCIALE.toLowerCase().indexOf(event.target.value.toLowerCase() )  > -1 )  || 
                                ( i.INDIRIZZO.toLowerCase().indexOf(event.target.value.toLowerCase() )  > -1 ) 
                         ) :  _items });    
    };

    
    render() {
        return (
        <div id="inner-container">
            <Label className='ms-fontSize-xxl titolo-pagina'>{this.state.titoloPagina}<span id='boxdettagliocliente'></span></Label>

            <div id='filtri'>
            
                
                <div className='boxsearch dettagliogruppo'>
                <label className='ms-bgColor-themePrimary ms-font-l-plus'><span>{this.state.utenzaGruppo.RAGIONE_SOCIALE}</span></label>
                <label className='ms-font-s-plus'><span>{this.state.utenzaGruppo.INDIRIZZO} {this.state.utenzaGruppo.CAP} {this.state.utenzaGruppo.COMUNE}</span></label>
                <label className='ms-font-s-plus'><span>{this.state.utenzaGruppo.EMAIL}</span></label>
                </div>
            
                <div className='boxsearch elencoutenti'>
                <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Filtra per Utenza</span></label>
                <div id='ricercapod'>
                    <div className="ms-ComboBoxCustomStyledExample">
                        Ricerca <br/>
                        <div className="ms-TextField-wrapper wrapper_df60a678">
                            <div className="ms-TextField-fieldGroup fieldGroup_df60a678">
                                <input type="text" onChange={this._onChangeFiltraUtenti} id="TextField81" className="ms-TextField-field field_df60a678 ms-font-m" />
                            </div>
                        </div>
                    </div>
                </div>
                </div>
             
             </div>

            <div id="warning" className={this.state.visualizzaWarning}>Non sono disponibili utenze</div>

            <div id="elencorichieste" className={"DetailListContainer " + this.state.visualizza}>
            
            <DetailsList
                items={this.state.utenti}
                columns={ azioni.restituisciColonneUtenti() }
                setKey="set"
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
                selectionPreservedOnEmptyClick={true}
                onItemInvoked={this._onItemInvoked}
                compact={true}
              />
            </div>

            <div id="boxdialogo"></div>
        </div>
        );
    }
};

export default ElencoUtenti;


// WEBPACK FOOTER //
// ./src/AcComponents/ElencoUtenti.js